export enum CslDetailsSections {
    Registry = "registry",
    Banks = "creditlines",
    Offices = "offices",
    PaymentModes = "payment-modes",
    Contacts = "contacts"
}

export enum SectionForms {
    HEADER_FORM = "HEADER_FORM",
    SDI_FORM = "SDI",
    CONTACT_FORM = "CONTACT_FORM",
    OFFICE_FORM = "OFFICE_FORM",
    OFFICE_DOMICILE_FORM = "OFFICE_DOMICILE_FORM",
    PERSON_FORM = "PERSON_FORM",
    TENANT_FORM = "TENANT_FORM"
}
